module.exports = __webpack_public_path__ + "static/media/Visual-Studio-Code-(VS-Code).6a23ad24.svg";